import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'wm-additional-fields',
  standalone: false,
  templateUrl: './additional-fields-janus.component.html',
  styleUrls: ['./additional-fields-janus.component.scss']
})
export class AdditionalFieldsJanusComponent implements OnInit {

  @Input() fields: any[] = [];
  isOpen = true;

  ngOnInit(): void {
  }

  // Added by Amisha on 2026-06-29.
  // Reason: Additional Fields can contain list-data JSON and calculated-value JSON,
  // so Janus should display the resolved value instead of the raw serialized payload.
  getDisplayValue(field: any): string {
    if (!field) {
      return 'N/A';
    }

    if (field.dataEntityType === 'list-data') {
      try {
        const parsed = JSON.parse(field.fieldValue);
        return parsed?.[0]?.text || parsed?.[0]?.value || 'N/A';
      } catch {
        return 'N/A';
      }
    }

    if (typeof field.fieldValue !== 'string') {
      return field.fieldValue || 'N/A';
    }

    const trimmedValue = field.fieldValue.trim();

    if (!trimmedValue) {
      return 'N/A';
    }

    if (trimmedValue.startsWith('{') || trimmedValue.startsWith('[')) {
      try {
        const parsedValue = JSON.parse(trimmedValue);

        if (Array.isArray(parsedValue)) {
          return parsedValue?.[0]?.text || parsedValue?.[0]?.value || 'N/A';
        }

        if (typeof parsedValue === 'object' && parsedValue !== null) {
          return (
            parsedValue.EditedValue ||
            parsedValue.CalculatedValue ||
            parsedValue.Value ||
            'N/A'
          );
        }
      } catch {
        return trimmedValue;
      }
    }

    return trimmedValue || 'N/A';
  }
}
